<!-- 移动端下载APP -->
<template>
  <div class="box">
    <!-- swiper滚动组件 -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide bgBox bgBox1">
          <h1 class="ffb" style="font-size: 32px">烟雨佳人 轻奢社交</h1>
          <div style="color:#fff;font-size: 16px" class="describe">
            轻奢只为遇见高品质的Ta
          </div>
          <button @click="download">下载烟雨佳人</button>
          <svg
            t="1614754586324"
            class="icon"
            id="downArrow"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="1927"
            :class="downArrowAniFlag ? 'downArrow-animation' : ''"
          >
            <path
              d="M891.180484 315.350225c-11.985986-11.993149-31.17707-12.242835-42.868343-0.557702L508.53662 654.40636 168.7611 314.792523c-11.69025-11.685133-30.881334-11.435447-42.868343 0.557702-11.985986 11.992125-12.226462 31.18321-0.536212 42.868343l361.745904 361.564779c5.873778 5.869684 13.640672 8.725732 21.435195 8.595772 7.794523 0.12996 15.560394-2.726088 21.431102-8.595772l361.745904-361.564779C903.406946 346.533434 903.166469 327.34235 891.180484 315.350225z"
              p-id="1928"
              fill="#e6e6e6"
            ></path>
          </svg>
        </div>
        <div class="swiper-slide bgBox bgBox2">
          <div class="text">
            <p>世界动态</p>
            <p>分享你的品质生活</p>
          </div>
          <div class="bg-circle-b">
            <div class="bg-circle-s"></div>
            <div class="phoneBG phoneBG1"></div>
          </div>
        </div>
        <div class="swiper-slide bgBox bgBox3">
          <div class="text">
            <p>资料主页</p>
            <p>多面展示你的个性</p>
          </div>
          <div class="bg-circle-b">
            <div class="bg-circle-s"></div>
            <div class="phoneBG phoneBG2"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 顶部下载栏 -->
    <div class="topDownload" :class="topDownloadFlag ? 'showTopDownload' : ''">
      <div class="logoBox">
        <div class="logo"></div>
        烟雨佳人
      </div>
      <button @click="download">下载</button>
    </div>
    <!-- 微信遮罩 微信禁止下载 -->
    <div class="weixinmask" v-show="weixinmaskFlag">
      <img src="..\assets\img\browser.png" alt="" />
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
// 这里可以导入其他文件 (比如：组件，工具js，第三方插件js，json文件，图片文件等等)
// 例如：import 《组件名称》 from '《组件路径》'
export default {
  name: "modieDownload",
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      // 当前滚动组件索引号
      currentSwiperIndex: 0,
      topDownloadFlag: false,
      downArrowAni: null,
      // 向下箭头动画开关
      downArrowAniFlag: false,
      // 微信遮罩 开关
      weixinmaskFlag: false
    };
  },
  // 计算属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 判断是否是微信
    isWeiXin: function() {
      var ua = window.navigator.userAgent.toLowerCase();
      // console.log(ua); //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    // 下载
    download: function() {
      if (
        this.versions().iPhone ||
        this.versions().iPad ||
        this.versions().ios
      ) {
        location.href = "https://itunes.apple.com/cn/app/id1545900973";
      } else if (this.versions().android) {
        location.href = "https://yyjrapp.com/yyjrapp_release.apk";
      }
    },
    // 区分 ios 和 安卓
    versions: function() {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        //移动终端浏览器版本信息
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
        iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1 //是否iPad
      };
    }
  },
  // 生命周期 - 创建完成 (可以访问当前this实例)
  created() {},
  // 生命周期 - 挂载完成 (可以访问DOM元素)
  mounted() {
    var _this = this;
    // 初始化Swiper
    var mySwiper = new Swiper(".swiper-container", {
      direction: "vertical", // 垂直切换选项
      loop: false, // 循环模式选项
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination"
      },
      on: {
        slideNextTransitionStart: function() {
          _this.currentSwiperIndex++;
          if (_this.currentSwiperIndex == 0) {
            _this.topDownloadFlag = false;
          } else {
            _this.topDownloadFlag = true;
          }
        },
        slidePrevTransitionStart: function() {
          _this.currentSwiperIndex--;
          if (_this.currentSwiperIndex == 0) {
            _this.topDownloadFlag = false;
          } else {
            _this.topDownloadFlag = true;
          }
        }
      }
    });
    // 向下箭头动画
    this.downArrowAni = setInterval(() => {
      this.downArrowAniFlag = !this.downArrowAniFlag;
    }, 500);
    // 移动端页面用rem布局
    document.querySelector("html").style.fontSize = "calc(100vw / 375)";
    // 如果是安卓手机 又是微信浏览器
    // 就需要用户打开自带浏览器下载
    if (this.versions().android) {
      if (this.isWeiXin()) {
        this.weixinmaskFlag = true;
      } else {
        // ?type=autoDownload  自动下载Apk
        if (window.location.hash.indexOf("autoDownload") != -1) {
          location.href = "https://yyjrapp.com/yyjrapp_release.apk";
        }
      }
    }
  },
  // 生命周期 - 销毁之前
  beforeDestroy() {
    // 清理定时器
    clearInterval(this.downArrowAni);
    this.downArrowAni = null;
    document.querySelector("html").style.fontSize = "";
  },
  // 生命周期 - 销毁完成
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* html {
      font-size: calc(100vw / 375);
    } */

/* @import url(路径); 引入公共css类 */
.swiper-container {
  width: 100%;
  height: 100vh;
}

/* swiper滚动组件 内容容器 */
.bgBox {
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  text-align: center;
  transform: translate3d(0, 0, 0);
  overflow: hidden;
  background-color: #000;
}

.bgBox .text {
  margin-top: 80rem;
}

.bgBox .text p {
  color: #fff;
  font-size: 24px;
}

div.bgBox1 {
  background-image: url(..\assets\img\modieBg.jpg);
}

/* 向下箭头 */
div.bgBox1 #downArrow {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 50%;
  margin-top: 150px;
  width: 26px;
  opacity: 0.8;
  transition: 0.5s all ease-out;
}

div.bgBox1 .downArrow-animation {
  margin-top: 160px !important;
}

.phoneBG {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  width: 50%;
  height: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.phoneBG1 {
  background-image: url(..\assets\img\1.1.png);
}

.phoneBG2 {
  background-image: url(..\assets\img\3.3.png);
}

.bg-circle-b {
  position: relative;
  background-color: rgba(255, 255, 255, 0.14);
  width: 480rem;
  height: 480rem;
  border-radius: 50%;
  margin-top: 20rem;
  margin-left: -240rem;
  left: 50%;
}

.bg-circle-s {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.04);
  width: 300rem;
  height: 300rem;
  border-radius: 50%;
  left: 50%;
  margin-left: -150rem;
  top: 50%;
  margin-top: -150rem;
}

.bgBox1 h1,
.bgBox1 .describe,
.bgBox1 button {
  position: absolute;
  color: #fff;
  width: 100%;
}

.bgBox1 h1 {
  top: 50%;
  margin-top: -24px;
}

.bgBox1 .describe {
  top: 50%;
  margin-top: 36px;
}

div.bgBox1 button {
  width: auto;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 80px;
  color: #000;
  border-radius: 25px;
  padding: 10px 20px;
  font-size: 20px;
  background-color: #fff;
}

div.bgBox1 button:active {
  background-color: #ccc;
}

/* 顶部下载栏 */
.topDownload {
  position: fixed;
  top: -60px;
  left: 0px;
  width: 100%;
  height: 60px;
  background-color: #343434;
  transition: top 0.3s;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.showTopDownload {
  top: 0px;
}

.topDownload .logoBox {
  height: 40px;
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 18px;
}

.topDownload .logo {
  width: 40px;
  height: 40px;
  background-image: url(..\assets\img\logo.png);
  background-repeat: no-repeat;
  background-size: 100%;
  border-radius: 10px;
  margin-right: 10px;
}

.topDownload button {
  color: #343434;
  background-color: #fff;
  border-radius: 25px;
  padding: 3px 15px;
  font-size: 16px;
}

/* 微信遮罩 */
.weixinmask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.52);
  z-index: 1000;
}

.weixinmask img {
  position: absolute;
  height: 36px;
  right: 10px;
  top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/modieDownload.vue